module.exports = __webpack_public_path__ + "static/img/naturalCircle7.e6dfabb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle7.svg
// module id = di45
// module chunks = 1